import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { LogIn } from "lucide-react";
import { api } from "@/lib/api";
import { Logo } from "@/components/Logo";

const inputCls =
  "w-full rounded-xl bg-ink border border-white/10 px-4 py-3 text-sm text-[#F8F6F0] placeholder:text-zinc-600 focus:outline-none focus:border-gold/60 focus:ring-1 focus:ring-gold/40 transition-colors";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/login", { email, password });
      navigate("/admin");
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Login failed. Check your credentials.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="min-h-screen bg-ink flex items-center justify-center px-4" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm gold-ring rounded-3xl bg-ink-card p-8" data-testid="admin-login-form">
        <div className="flex justify-center mb-8"><Logo /></div>
        <h1 className="font-serif text-2xl text-center text-[#F8F6F0]">Team sign in</h1>
        <p className="text-xs text-zinc-500 text-center mt-2 mb-7">Owner access to bookings, guide content and projects.</p>
        <div className="space-y-4">
          <input type="email" required data-testid="admin-email-input" placeholder="Email"
                 value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} />
          <input type="password" required data-testid="admin-password-input" placeholder="Password"
                 value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} />
          <button type="submit" disabled={busy} data-testid="admin-login-submit-btn"
                  className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-gold px-7 py-3.5 text-sm font-semibold text-ink hover:bg-gold-hover disabled:opacity-60 transition-colors">
            {busy ? "Signing in…" : "Sign in"} <LogIn size={15} />
          </button>
        </div>
        <a href="/" className="block text-center text-xs text-zinc-600 hover:text-zinc-400 mt-6 transition-colors" data-testid="admin-login-back-link">
          ← Back to site
        </a>
      </form>
    </main>
  );
}
